import { ActionType } from '../ActionTypes';
import { StoreAction } from '../Store';
import { GeolocationState } from './GeolocationState';

// Note that we don't have loading and error states as the users never need to know about this.
export type GeolocationAction = {
  type: ActionType.INITIALIZE_GEOLOCATION;
  data: GeolocationState;
};

export function geolocationReducer(state: GeolocationState, action: StoreAction): GeolocationState {
  switch (action.type) {
    case ActionType.INITIALIZE_GEOLOCATION: {
      // Note INITIALIZE_GEOLOCATION is also handled in the pricing reducer.
      return action.data;
    }
    default:
      return state;
  }
}
